import React from 'react';

import { useNetworkState } from 'react-use';

import { alert } from '@components/ui';

import { Notification } from './Notification';

export const NetworkStatusChecker: React.FC = () => {
  const state = useNetworkState();

  const [centredModal, setCentredModal] = React.useState(false);

  React.useEffect(() => {
    if (state.online === false) {
      setCentredModal(true);
    }
    if (state.online === true && state.previous === false) {
      alert.success('You are online again.');
      setCentredModal(false);
    }
  }, [state.online, state.previous]);

  return <Notification show={centredModal} />;
};
